// Damage-element resolver. See ADR 0008 §2.10.
//
// Substitutes 'weapon-derived' with the caster's equipped-weapon attack
// element. Until the equipment system lands, callers pass an entity-like
// object that may carry a `weaponElement?: Element` field; absence falls
// back to 'physical'. `Entity.element` (defender-side affinity per docs/05
// §5.7.1 Layer C) is intentionally NOT used as a fallback to avoid mixing
// attacker/defender semantics.
export function resolveDamageElement(element, caster) {
    if (element !== 'weapon-derived')
        return element;
    return caster.weaponElement ?? 'physical';
}
//# sourceMappingURL=element-resolver.js.map